import React from 'react';
import { withTranslation } from 'react-i18next';
import Backend from '../../../../Layouts/Backend';
import { Dropdown, Input, Alert, Button } from '../../../../UI/Common';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Form, FormFeedback, FormGroup, Label } from 'reactstrap';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import Required from '../../../../UI/Required';
import ReactSelect from '../../../../UI/ReactSelect';

const NewMKTMonitorPage = (props) => {
  const { t, isSubmitting, sensors = [] } = props;
  const form = {
    sensorId: '',
    sensorName: '',
    sampleId: '',
    startTime: new Date(),
  };
  return (
    <Backend>
      <div className="content-inner">
        <Formik
          initialValues={form}
          validationSchema={validationSchema}
          onSubmit={(values) => props.onCreateMKT(values)}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldValue,
            setFieldTouched,
            touched,
            isValid,
            handleSubmit,
          }) => {
            return (
              <Form>
                <ReactSelect
                  required
                  containerStyle={{ width: '50%' }}
                  label="Sensor"
                  options={sensors}
                  value={values.sensorId}
                  onChange={({ value }) => {
                    setFieldValue('sensorId', value);
                  }}
                  valueKey="id"
                  labelKey="name"
                  invalid={touched.sensorId}
                  error={errors.sensorId}
                />
                <Input
                  required
                  inputClass="w-50"
                  id="sampleId"
                  label="Sample"
                  onChange={handleChange('sampleId')}
                  value={values.sampleId}
                  invalid={touched.sampleId}
                  error={errors.sampleId}
                />
                <FormGroup>
                  <Label htmlFor="startTime">
                    {t('Start Time')} <Required />
                  </Label>
                  <DatePicker
                    id="startTime"
                    className="form-control"
                    selected={values.startTime}
                    onChange={(date) => setFieldValue('startTime', date)}
                    showTimeSelect
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="MM/dd/yyyy H:mm"
                  />
                  {errors.startTime && touched.startTime && (
                    <FormFeedback>{t(errors.startTime)}</FormFeedback>
                  )}
                </FormGroup>
                <Alert.Error text={props.errors} />
                <Button
                  id="create-mkt-monitor-btn"
                  loading={isSubmitting}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                  <i className="md-icon">done</i>
                  {t('Create')}
                </Button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(NewMKTMonitorPage);
